var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4746 3.5H15.4746C16.005 3.5 16.5137 3.71071 16.8888 4.08579C17.2639 4.46086 17.4746 4.96957 17.4746 5.5V19.5C17.4746 20.0304 17.2639 20.5391 16.8888 20.9142C16.5137 21.2893 16.005 21.5 15.4746 21.5H3.47461C2.94418 21.5 2.43547 21.2893 2.0604 20.9142C1.68532 20.5391 1.47461 20.0304 1.47461 19.5V5.5C1.47461 4.96957 1.68532 4.46086 2.0604 4.08579C2.43547 3.71071 2.94418 3.5 3.47461 3.5H5.47461",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4746 1.5H6.47461C5.92232 1.5 5.47461 1.94772 5.47461 2.5V4.5C5.47461 5.05228 5.92232 5.5 6.47461 5.5H12.4746C13.0269 5.5 13.4746 5.05228 13.4746 4.5V2.5C13.4746 1.94772 13.0269 1.5 12.4746 1.5Z",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/detail_icon.033a141d3fe32ac1e579cedb0fd9b75a.svg";
export { ForwardRef as ReactComponent };